import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";

const ShiftForm = ({ onSuccess }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    start_time: "",
    end_time: "",
    flex_start: "",
    flex_end: "",
    is_flexible: false,
    is_double: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...form,
        start_time: form.start_time || null,
        end_time: form.end_time || null,
        flex_start: form.flex_start || null,
        flex_end: form.flex_end || null,
      };

      await axios.post("shifts/", payload);
      alert("Shift created successfully");
      setForm({
        name: "",
        start_time: "",
        end_time: "",
        flex_start: "",
        flex_end: "",
        is_flexible: false,
        is_double: false,
      });

      onSuccess && onSuccess();
    } catch (err) {
      console.error(err);
      alert("Failed to create shift");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="card p-3 mb-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Create Shift</h5>
        <button type="button" className="btn btn-sm btn-secondary" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </button>
      </div>

      <input
        name="name"
        placeholder="Shift Name"
        className="form-control mb-2"
        value={form.name}
        onChange={handleChange}
        required
      />

      <label>Start Time</label>
      <input
        type="time"
        name="start_time"
        className="form-control mb-2"
        value={form.start_time}
        onChange={handleChange}
      />

      <label>End Time</label>
      <input
        type="time"
        name="end_time"
        className="form-control mb-2"
        value={form.end_time}
        onChange={handleChange}
      />

      <label>Flexible Start</label>
      <input
        type="time"
        name="flex_start"
        className="form-control mb-2"
        value={form.flex_start}
        onChange={handleChange}
      />

      <label>Flexible End</label>
      <input
        type="time"
        name="flex_end"
        className="form-control mb-2"
        value={form.flex_end}
        onChange={handleChange}
      />

      <div className="form-check">
        <input
          type="checkbox"
          name="is_flexible"
          className="form-check-input"
          checked={form.is_flexible}
          onChange={handleChange}
        />
        <label className="form-check-label">Flexible Shift</label>
      </div>

      <div className="form-check">
        <input
          type="checkbox"
          name="is_double"
          className="form-check-input"
          checked={form.is_double}
          onChange={handleChange}
        />
        <label className="form-check-label">Double Shift</label>
      </div>

      <button className="btn btn-primary mt-3">Save Shift</button>
    </form>
  );
};

export default ShiftForm;
